import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React from "react";
import { useHistory } from "react-router-dom";

export default function P214Search({ data, data_A, data_B, indexTab }) {
    const handlerConNme = () => {
        if (indexTab === 0) {
            if (data_A.length > 0) return data_A[0].contractorName;
        } else {
            if (data_B.length > 0) return data_B[0].contractorName;
        }
    };

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
                <label htmlFor="">เลขที่สัญญา</label>
                <InputText type="text" placeholder="เลขที่สัญญา" value={data.contractNo} disabled />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <label htmlFor="">บริษัท</label>
                <InputText type="text" placeholder="บริษัท" disabled value={handlerConNme()} />
            </div>
        </div>
    );
}
